import { es } from '../strings/es.ts'

/**
 * El teclado propio evita que el del sistema tape media pantalla en la tablet.
 *
 * Con coma y con signo menos: desde cuarto hay decimales y en sexto hay números
 * negativos, y un teclado sin ellos convierte un ejercicio del temario en uno
 * imposible de contestar.
 */
const TECLAS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ',', '-']

const LARGO_MAXIMO = 8

export function Teclado({
  escrito,
  onEscrito,
  onComprobar,
  comprobar = es.mates.comprobar,
}: {
  escrito: string
  onEscrito: (escrito: string) => void
  onComprobar: () => void
  comprobar?: string
}) {
  return (
    <>
      <p aria-live="off" className="mt-6 mb-0 text-center text-4xl font-extrabold tabular-nums">
        <span className="sr-only">{es.mates.tuRespuesta}: </span>
        {escrito === '' ? '·' : escrito}
      </p>

      <div className="mt-6 grid grid-cols-4 gap-2">
        {TECLAS.map((tecla) => (
          <button
            key={tecla}
            type="button"
            className="border-rule bg-surface min-h-16 rounded-xl border text-2xl font-bold tabular-nums"
            onClick={() => {
              if (escrito.length < LARGO_MAXIMO) onEscrito(escrito + tecla)
            }}
          >
            {tecla}
          </button>
        ))}
      </div>

      <div className="mt-3 flex gap-2">
        <button
          type="button"
          className="border-rule min-h-14 flex-1 rounded-xl border px-4 font-bold"
          onClick={() => {
            onEscrito(escrito.slice(0, -1))
          }}
        >
          {es.mates.borrar}
        </button>
        <button
          type="button"
          className="bg-teal min-h-14 flex-1 rounded-xl px-4 text-lg font-bold text-white disabled:opacity-50"
          disabled={escrito === ''}
          onClick={onComprobar}
        >
          {comprobar}
        </button>
      </div>
    </>
  )
}
